import JSZip from 'jszip';
import { convertJST } from './convertJST';
import { Version } from '../generated/graphql';

/**
 * @param version
 */
export const downloadFile = (version: Version) => {
  const zip = new JSZip();
  const folder = zip.folder('folder');
  const updateDate = convertJST(version.updated_at);
  const _date = updateDate?.split(' ')[0].split('-').join('');
  const _time = updateDate?.split(' ')[1].split(':').join('');
  if (folder) {
    folder.file(`${version.variation_id}.js`, version.js);
    folder.file(`${version.variation_id}.css`, version.css);
    folder.generateAsync({ type: 'blob' }).then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.download = `${version.variation_id}-${_date}-${_time}.zip`;
      a.href = url;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
  }
};
